<template>
    <div class="tabs-container">
        <DxTabs :data-source="tabs" v-model:selected-index="selectedIndex" @option-changed="onTabChanged"
            :item-template="tabTemplate" />
        <div v-if="selectedIndex === 0">
            <GridTabOportunitati @select-opportunity="onOpportunitySelected" />
        </div>
        <div v-if="selectedIndex === 1">
            <GridOportunitatiDetalii :opportunity="selectedOpportunity" @back="selectedIndex = 0" @refresh-data="fetchOpportunity(selectedOpportunity.ID)" />
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { DxTabs } from 'devextreme-vue/tabs';
import GridTabOportunitati from './GridTabOportunitati.vue';
import GridOportunitatiDetalii from './GridOportunitatiDetalii.vue';
import CrmSales from '@/services/Comercial/CrmSales';
import DataSource from 'devextreme/data/data_source';
import AppSetting from '@/settings/appSettings';

export default defineComponent({
    components: {
        DxTabs,
        GridTabOportunitati,
        GridOportunitatiDetalii
    },
    data() {
        return {
            tabs: [
                { text: 'Oportunitati' },
                { text: 'Detalii' },
            ],
            selectedIndex: 0,
            selectedOpportunity: null
        };
    },
    mounted() {
        if (this.$route.query.opportunityId) {
            const id = this.$route.query.opportunityId as string;
            this.fetchOpportunity(id);
        }
    },
    watch: {
        '$route.query.opportunityId': {
            handler(newId) {
                if (newId) {
                    this.fetchOpportunity(newId as string);
                }
            },
            immediate: true
        }
    },
    methods: {
        onTabChanged(e: any) {
            this.selectedIndex = e.component.option('selectedIndex');
        },
        tabTemplate(itemData: any) {
            return `<div>${itemData.text}</div>`;
        },
        onOpportunitySelected(opportunity: any) {
            this.selectedOpportunity = opportunity;
            this.selectedIndex = 1;
        },
        fetchOpportunity(id: string) {
            const ds = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'CRM_Sales',
                    key: 'ID',
                    keyType: 'Guid',
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
                        };
                        e.params.$expand = 'Account($select=Nume),Contact($select=Nume,Prenume),Campanie($select=Denumire),Valuta($select=Simbol),Sursa($select=Nume),Proiect($select=Cod),Status($select=Nume)';
                    },
                },
                filter: ['ID', '=', id],
            });

            ds.load().then((response) => {
                if (response && response.length > 0) {
                    this.selectedOpportunity = response[0];
                    this.selectedIndex = 1;
                }
            }).catch(error => {
                console.error("Error fetching opportunity:", error);
            });
        }
    }

});
</script>
<style scoped></style>